export default "__VITE_ASSET__B65D9DzR__"